import { createClient } from '@supabase/supabase-js';

import type { Database } from '@/shared/types/database.types';

/**
 * Client único do Supabase (architecture.md §5.1).
 *
 * Só a camada `api/` de cada feature importa este módulo — o lint impede o
 * resto. Isso mantém a superfície de rede testável e permite trocar uma
 * consulta por RPC sem tocar em UI.
 *
 * A `anon key` é pública por design: ela vai para o bundle e qualquer pessoa
 * pode lê-la. Quem protege o dado é a RLS (RNF-S01). A `service_role key`
 * nunca entra aqui nem em nada sob `src/` (RNF-S06) — ela vive apenas nos
 * scripts de `scripts/admin/`.
 */

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY são obrigatórias. Copie .env.example para .env.local e preencha.',
  );
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    // Sessão sobrevive ao fechamento do navegador (US-03: mínimo 7 dias).
    // A duração em si é configurada no Supabase Auth, não aqui.
    persistSession: true,
    autoRefreshToken: true,
    // Login é por código de 6 dígitos digitado (verifyOtp em auth.api.ts),
    // nunca por link na URL — desligado por padrão para não haver detecção
    // automática de sessão a partir de query param nenhum.
    detectSessionInUrl: false,
  },
});
